globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

appCustomerSpace.LimitlessPlugins.Checkbox = (function(){

  Checkbox.selector = '[data-plugin="limitless.checkbox"]';

  Checkbox.init = function($html) {
    $html.find(Checkbox.selector).each(function() {
      new Checkbox($(this));
    })

    // Handle with-opacity class
    $html.find('div.checkbox.with-opacity').each(function(){
      if(!$(this).find('input').is(':checked')) {
        $(this).addClass('unchecked');
      }
    })

    $html.find('div.checkbox.with-opacity').on('change', 'input[type=checkbox]', function(){
      var $this = $(this);
      var $checkBoxContainer = $this.closest('div.checkbox');

      ($this.is(':checked')) ? $checkBoxContainer.removeClass('unchecked') : $checkBoxContainer.addClass('unchecked');
    });
  }

  function Checkbox($html) {
    this.$html = $html;
    this.init();
  }

  Checkbox.prototype = {
    init: function(){
      var Checkbox = this,
          options  = Checkbox.$html.data("plugin-options") || {},
          defaults = {
            radioClass: 'choice'
          }

      Checkbox.$html.uniform($.extend({}, defaults, options, true));
    }
  }

  return Checkbox;

})();
